<template>
    <div>
        
        <fieldset id="formParticulars">
            
			<h2>Particulars</h2>
			<b-form-group
                id="lastName-group"
                label="Family Name:"
                label-for="lastName"
				description="(as per passport)"
            >
                <b-form-input
                id="lastName"
                v-model="formData.lastName"
                type="text"
                required
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="firstName-group"
                label="Given Name:"
                label-for="firstName"
				description="(as per passport)"
            >
                <b-form-input
                id="firstName"
                v-model="formData.firstName"
                type="text"
                required
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="jobTitle-group"
                label="Job Title:"
                label-for="jobTitle"
            >
                <b-form-input
                id="jobTitle"
                v-model="formData.jobTitle"
                type="text"
                required
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="department-group"
                label="Department:"
                label-for="department"
            >
                <b-form-select id="department" v-model="formData.department" :options="departmentOptions"></b-form-select>
            </b-form-group>
			<b-form-group
                id="dateOfBirth-group"
                label="Date of Birth:"
                label-for="dateOfBirth"
            >

                <Datepicker id="dateOfBirth" 
                    name="dateOfBirth" 
                    v-model="formData.dateOfBirth" 
                    required 
                    aria-required="true" 
                    input-class="form-control" 
                    :format="customFormatter"
                    typeable
                ></Datepicker>
                
            </b-form-group>
			<b-form-group
                id="nationality-group"
                label="Nationality:"
                label-for="nationality"
            >
                <b-form-input
                id="nationality"
                v-model="formData.nationality"
                type="text"
                required
				maxlength="50"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="passportNo-group"
                label="Passport Number:"
                label-for="passportNo"
            >
                <b-form-input
                id="passportNo"
                v-model="formData.passportNo"
                type="text"
                required
				maxlength="20"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="passportExpiry-group"
                label="Date of Expiry:"
                label-for="passportExpiry"
            >

                <Datepicker 
                    id="passportExpiry" 
                    name="passportExpiry" 
                    v-model="formData.passportExpiry" 
                    required 
                    aria-required="true" 
                    input-class="form-control" 
                    :format="customFormatter"
                    typeable    
                ></Datepicker>
                
            </b-form-group>
			<b-form-group
                id="email-group"
                label="Email:"
                label-for="email"
            >
                <b-form-input
                id="email"
                v-model="formData.email"
                type="text"
                required
				maxlength="50"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="emergencyName-group"
                label="Emergency Name:"
                label-for="emergencyName"
            >
                <b-form-input
                id="emergencyName"
                v-model="formData.emergencyName"
                type="text"
                required
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="emergencyRelationship-group"
                label="Emergency Relationship:"
                label-for="emergencyName"
            >
                <b-form-input
                id="emergencyRelationship"
                v-model="formData.emergencyRelationship"
                type="text"
                required 
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="emergencyContact-group"
                label="Emergency Contact:"
                label-for="emergencyContact"
            >
                <b-form-input
                id="emergencyContact"
                v-model="formData.emergencyContact"
                type="text"
                required 
				maxlength="25"
                ></b-form-input>
            </b-form-group>
			<b-form-group
                id="remarks-group"
                label="Remarks:"
                label-for="remarks"
            >
                
				<b-form-textarea
                id="remarks"
                v-model="formData.remarks"
                placeholder=""
                rows="8"
                max-rows="6" 
				maxlength="500"
                ></b-form-textarea>
            </b-form-group>
										
		</fieldset>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'FormParticulars',
    components: {
        Datepicker
    },
	props: [
        'formData',
        'dateFormat'
    ],
	data() {
		return {
			departmentOptions: [
				{ value: null, text: 'Please select an option' },
				{ value: 'Global Admin', text: 'Global Admin' },
				{ value: 'Global HR', text: 'Global HR' },
				{ value: 'Global R&D', text: 'Global R&D' },
				{ value: 'Global QA/RA/CTM', text: 'Global QA/RA/CTM' },
				{ value: 'Global Finance', text: 'Global Finance' },
				{ value: 'Global IT', text: 'Global IT' },
				{ value: 'Global Operations', text: 'Global Operations' },
				{ value: 'Galileo', text: 'Galileo' },
				{ value: 'Global Operations', text: 'Global Operations' },
				{ value: 'Strategic Marketing & Business Development', text: 'Strategic Marketing & Business Development' },
				{ value: 'Global Sales', text: 'Global Sales' },
				{ value: 'Japan Sales & Marketing', text: 'Japan Sales & Marketing' }
            ],
            customFormatter: this.dateFormat
		}
	}
}
</script>

<style lang="less" scoped>

</style>